// src/Components/PrivateRoute.jsx
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from './Services/Loader';

const PrivateRoute = ({ component: Component, requiredRole, lastRoute}) => {
  // const [loading, setLoading] = useState(true);
  const location = useLocation();


  const { user, role, isloading } = useSelector((state) => state.auth)    //Custom Auth variables

  useEffect(() => {

    if (!isloading && user) {
      localStorage.setItem("lastroute", location.pathname)
    }

  }, [location.pathname, isloading, user])



  if (isloading) {
    return <Loader/>;  // Show a loader while verifying session
  }

  // if (!user.is_active) {
  //   return <Navigate to='/' replace />;
  // }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  // if (user && location.pathname === '/') {
  //   <Navigate to="/database" replace />
  // }

  // If authenticated, render the component, otherwise redirect to login
  return user && <Component role={role} lastRoute = {lastRoute}/>
};

export default PrivateRoute;

// : <Navigate to="/" state={{ from: location }} replace />;